import { createFileRoute } from '@tanstack/react-router';

import { workflowTemplatesQueryOptions, WorkflowTemplatesPage } from '@/features/workflows';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/workflows/')({
  staticData: { tours: ['workflows.list'] },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...workflowTemplatesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: WorkflowTemplatesPage,
});
